/**
 * Pricing and credit cost constants
 *
 * Centralized so pricing changes don't require hunting through components.
 */

// AI image generation — approximate credit cost shown to users
export const AI_CREDITS_FLASH_IMAGE = 130; // gemini-2.5-flash-image
export const AI_CREDITS_PRO_IMAGE = 240; // gemini-3-pro-image-preview

// TTS audio generation — USD cost per 1,000 characters
export const TTS_USD_PER_1K_CHARS = 0.015;

// Credit top-up pack sizes (must match RevenueCat product catalog)
export const CREDIT_PACK_SMALL = 1000;
export const CREDIT_PACK_LARGE = 5000;
